document.addEventListener('DOMContentLoaded', () => {
  /**
   * Finds all modal opener buttons and the main overlay element in the DOM.
   * @type {NodeListOf<Element>}
   */
  const modalOpeners = document.querySelectorAll('[data-modal-opener]');
  /**
   * The main overlay element where modal content will be teleported.
   * @type {Element}
   */
  const overlay = document.querySelector('.js-overlay');

  // If there are no modal openers or no overlay, do nothing.
  if (modalOpeners.length === 0 || !overlay) return;

  modalOpeners.forEach((opener) => {
    opener.addEventListener('click', () => {
      const contentId = opener.getAttribute('data-modal-content');
      const contentElement = document.getElementById(contentId);

      if (!contentId || !contentElement) {
        console.error(`Modal content with ID #${contentId} not found.`);
        return;
      }

      // Remember what had focus so we can restore it when the modal closes.
      overlay._lastFocused = document.activeElement;

      // --- Teleportation Logic ---
      // 1. Clone the content and teleport it into the overlay.
      const modalContent = contentElement.innerHTML;
      overlay.innerHTML = modalContent;
      overlay.classList.add('is-visible');

      // --- Event Listeners for Closing ---
      // 2. Find the close button within the newly added content and attach a listener.
      const closeBtn = overlay.querySelector('.js-close-modal');
      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }

      // Move focus into the dialog and trap it there while open (a11y / WCAG 2.4.3).
      const dialog = overlay.querySelector('[role="dialog"]') || overlay;
      dialog.setAttribute('tabindex', '-1');
      (closeBtn || dialog).focus();

      const getFocusables = () =>
        overlay.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
      const trapHandler = (e) => {
        if (e.key !== 'Tab') return;
        const items = getFocusables();
        if (items.length === 0) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
      overlay.addEventListener('keydown', trapHandler);
      overlay._trapHandler = trapHandler;

      // 3. Add a listener to the overlay itself to close when the background is clicked.
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          closeModal();
        }
      });

      // 4. Add a listener for the 'Escape' key to close the modal.
      const escapeHandler = (e) => {
        if (e.key === 'Escape') {
          closeModal();
        }
      };
      document.addEventListener('keydown', escapeHandler);

      // Store the handler on the overlay element itself so we can remove it later.
      overlay._escapeHandler = escapeHandler;
    });
  });

  /**
   * Closes the modal, cleans up content, and removes event listeners.
   */
  function closeModal() {
    overlay.classList.remove('is-visible');
    // Clear the overlay content completely.
    overlay.innerHTML = '';

    // Remove the 'Escape' key listener to prevent memory leaks.
    if (overlay._escapeHandler) {
      document.removeEventListener('keydown', overlay._escapeHandler);
      delete overlay._escapeHandler;
    }

    // Remove the focus trap and return focus to the element that opened the modal.
    if (overlay._trapHandler) {
      overlay.removeEventListener('keydown', overlay._trapHandler);
      delete overlay._trapHandler;
    }
    if (overlay._lastFocused && typeof overlay._lastFocused.focus === 'function') {
      overlay._lastFocused.focus();
      delete overlay._lastFocused;
    }
  }
});
